/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Do_This_LaterInputs */

const en_do_this_later = /** @type {(inputs: Do_This_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do this later`)
};

const es_do_this_later = /** @type {(inputs: Do_This_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hacer esto más tarde`)
};

const fr_do_this_later = /** @type {(inputs: Do_This_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire cela plus tard`)
};

const de_do_this_later = /** @type {(inputs: Do_This_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Später machen`)
};

const ja_do_this_later = /** @type {(inputs: Do_This_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`後で行う`)
};

const zh_do_this_later = /** @type {(inputs: Do_This_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稍后再做`)
};

const ar_do_this_later = /** @type {(inputs: Do_This_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سأفعل هذا لاحقاً`)
};

const id_do_this_later = /** @type {(inputs: Do_This_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lakukan ini nanti`)
};

const it_do_this_later = /** @type {(inputs: Do_This_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallo in seguito`)
};

const ru_do_this_later = /** @type {(inputs: Do_This_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сделать это позже`)
};

const pt_do_this_later = /** @type {(inputs: Do_This_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer isso depois`)
};

const ko_do_this_later = /** @type {(inputs: Do_This_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나중에 하기`)
};

/**
* | output |
* | --- |
* | "Do this later" |
*
* @param {Do_This_LaterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const do_this_later = /** @type {((inputs?: Do_This_LaterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Do_This_LaterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_do_this_later(inputs)
	if (locale === "es") return es_do_this_later(inputs)
	if (locale === "fr") return fr_do_this_later(inputs)
	if (locale === "de") return de_do_this_later(inputs)
	if (locale === "ja") return ja_do_this_later(inputs)
	if (locale === "zh") return zh_do_this_later(inputs)
	if (locale === "ar") return ar_do_this_later(inputs)
	if (locale === "id") return id_do_this_later(inputs)
	if (locale === "it") return it_do_this_later(inputs)
	if (locale === "ru") return ru_do_this_later(inputs)
	if (locale === "pt") return pt_do_this_later(inputs)
	return ko_do_this_later(inputs)
});